import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { colors, fontFamilyRegular, spacing } from '../../theme';
import { Text, TextProps } from '../Text';

export type TagProps = {
	text: string;
	color?: 'primary' | 'danger';
	size?: 'small' | 'medium';
	style?: StyleProp<ViewStyle>;
} & Pick<TextProps, 'numberOfLines'>;

export const Tag = ({
	text,
	color = 'primary',
	size = 'medium',
	style,
	numberOfLines,
}: TagProps) => {
	return (
		<View style={[styles.root, color === 'danger' ? styles.bgDanger : styles.bgPrimary, style]}>
			<Text
				status={color}
				style={size === 'small' ? styles.textSmall : styles.textMedium}
				numberOfLines={numberOfLines}
			>
				{text}
			</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		paddingVertical: spacing(),
		paddingHorizontal: spacing(2),
		borderRadius: 24,
	},
	bgPrimary: {
		backgroundColor: colors.black200,
	},
	bgDanger: {
		backgroundColor: colors.danger100,
	},
	textSmall: {
		fontFamily: fontFamilyRegular,
		fontWeight: '500',
		fontSize: 14,
		lineHeight: 14,
	},
	textMedium: {
		fontFamily: fontFamilyRegular,
		fontWeight: '500',
		fontSize: 16,
		lineHeight: 16,
	},
});
